export const CardAvatarDisabled = () => {
  return (
    <svg
      width="230"
      height="230"
      viewBox="0 0 57 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.8334 6.22143C30.8334 9.10512 28.4957 11.4428 25.612 11.4428C22.7283 11.4428 20.3906 9.10512 20.3906 6.22143C20.3906 3.33769 22.7283 1 25.612 1C28.4957 1 30.8334 3.33769 30.8334 6.22143Z"
        fill="white"
      />
      <path
        d="M1 50.2305V30.4633C1 25.5198 5.0075 21.5123 9.951 21.5123H41.2795C46.2231 21.5123 50.2305 25.5198 50.2305 30.4633V50.2305C50.2305 55.1741 46.2231 59.1815 41.2795 59.1815H9.951C5.0075 59.1815 1 55.1741 1 50.2305Z"
        fill="#D7E0FF"
      />
      <path
        d="M30.8334 6.22143C30.8334 9.10512 28.4957 11.4428 25.612 11.4428C22.7283 11.4428 20.3906 9.10512 20.3906 6.22143C20.3906 3.33769 22.7283 1 25.612 1C28.4957 1 30.8334 3.33769 30.8334 6.22143Z"
        stroke="#6150AD"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6211 11.4424V21.5123"
        stroke="#6150AD"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 45C24 45 24.6286 45 26 45C27.3714 45 28 45 28 45"
        stroke="#6150AD"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51 10C51 10 51.7857 10 53.5 10C55.2143 10 56 10 56 10"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51 15C51 15 51.7857 15 53.5 15C55.2143 15 56 15 56 15"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51 15C51 15 51.7857 14.2143 53.5 12.5C55.2143 10.7857 56 10 56 10"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 19C50 19 50.4714 19 51.5 19C52.5286 19 53 19 53 19"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 22C50 22 50.4714 22 51.5 22C52.5286 22 53 22 53 22"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 22C50 22 50.4714 21.5286 51.5 20.5C52.5286 19.4714 53 19 53 19"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46 16C46 16 46.3143 16 47 16C47.6857 16 48 16 48 16"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46 18C46 18 46.3143 18 47 18C47.6857 18 48 18 48 18"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46 18C46 18 46.3143 17.6857 47 17C47.6857 16.3143 48 16 48 16"
        stroke="#6150AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4126 33.5399C18.4126 34.1579 17.9116 34.6588 17.2937 34.6588C16.6757 34.6588 16.1748 34.1579 16.1748 33.5399"
        stroke="#6150AD"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.9282 33.5399C35.9282 34.1579 35.4272 34.6588 34.8093 34.6588C34.1914 34.6588 33.6904 34.1579 33.6904 33.5399"
        stroke="#6150AD"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 50.2305V30.4633C1 25.5198 5.0075 21.5123 9.951 21.5123H41.2795C46.2231 21.5123 50.2305 25.5198 50.2305 30.4633V50.2305C50.2305 55.1741 46.2231 59.1815 41.2795 59.1815H9.951C5.0075 59.1815 1 55.1741 1 50.2305Z"
        stroke="#6150AD"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
